import { RouteRecordRaw } from "vue-router"

const PaymentLogs = () => import("@/views/other/PaymentLogs.vue")

export const paymentLogsRoutes: RouteRecordRaw[] = [
    {
        path: "/admin/payment-logs",
        component: PaymentLogs,
        name: "paymentLogs",
        meta: {
            label: "Payment Logs",
            description: "View payment transaction logs for users"
        }
    }
]

export default paymentLogsRoutes
